// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* games/sliding/SlidingPuzzle.css */

/* --- ГЛАВНЫЙ КОНТЕЙНЕР (ДЕРЕВЯННАЯ ШКАТУЛКА) --- */
.sliding-board {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 360px;

  /* Текстура темного лакированного дерева */
  background:
    linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.4)),
    repeating-linear-gradient(45deg, #3e2723 0px, #4e342e 10px, #3e2723 20px);

  /* Золотая/Латунная окантовка */
  border: 6px solid #bcaaa4;
  outline: 2px solid #3e2723;
  border-radius: 12px;

  /* Глубокая тень (объем) */
  box-shadow:
    inset 0 0 30px rgba(0,0,0,0.8),
    0 20px 60px rgba(0,0,0,0.7);

  padding: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 6000;
  font-family: 'Georgia', 'Times New Roman', serif;
  color: #f5f5f5;
  -webkit-user-select: none;
          user-select: none;
}

/* Болтики по углам */
.sliding-board::before, .sliding-board::after {
  content: ''; position: absolute; top: 10px; width: 10px; height: 10px;
  background: radial-gradient(circle at 30% 30%, #ffd54f, #ff6f00);
  border-radius: 50%; box-shadow: 0 1px 2px rgba(0,0,0,0.5);
}
.sliding-board::before { left: 10px; }
.sliding-board::after { right: 10px; }

/* --- ЗАГОЛОВОК --- */
.sliding-header {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  border-bottom: 2px solid rgba(255,255,255,0.1);
  padding-bottom: 10px;
}

.sliding-title {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 2px;
  color: #d7ccc8;
  text-transform: uppercase;
  text-shadow: 0 2px 2px rgba(0,0,0,0.8);
}

.sliding-stats {
  margin-top: 5px;
  font-size: 14px;
  color: #a1887f;
  font-family: monospace;
  font-weight: bold;
}

/* --- ПОЛЕ ИГРЫ (УГЛУБЛЕНИЕ) --- */
.sliding-grid {
  display: grid;
  gap: 8px; /* Зазор между плитками */
  width: 100%;
  /* Удаляем aspect-ratio: 1 / 1 */
  /* Темное дно шкатулки */
  background: #211512;
  padding: 10px;
  border-radius: 8px;

  /* Внутренняя тень создает эффект углубления */
  box-shadow: inset 0 2px 15px rgba(0,0,0,0.9);
}

/* --- ПЛИТКА (ЭМАЛЬ И ЛАТУНЬ) --- */
.sliding-tile {
  position: relative;

  /* Эффект слоновой кости / эмали */
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);

  /* Текст */
  color: #3e2723;
  /* Удаляем фиксированный font-size: 32px */
  font-weight: 900;

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  cursor: pointer;

  /* Объем плитки */
  box-shadow:
    0 4px 0 #8d6e63, /* Толщина плитки */
    0 6px 5px rgba(0,0,0,0.5); /* Тень от плитки */

  transition: transform 0.1s;
}

.sliding-tile:active {
  transform: translateY(3px);
  box-shadow:
    0 1px 0 #8d6e63,
    0 2px 2px rgba(0,0,0,0.5);
}

/* Пустая ячейка - просто прозрачная */
.sliding-tile.empty {
  background: transparent;
  box-shadow: none;
  cursor: default;
}

/* Декоративная рамка внутри плитки (как на классических кубиках) */
.sliding-tile:not(.empty)::after {
  content: '';
  position: absolute;
  top: 4px; left: 4px; right: 4px; bottom: 4px;
  border: 1px solid rgba(62, 39, 35, 0.2);
  border-radius: 4px;
}

/* --- ОВЕРЛЕЙ ПОБЕДЫ (БУМАЖНЫЙ ЛИСТ) --- */
.sliding-result-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 50;
  animation: fadeIn 0.4s;
}

.result-card {
  background: #fff8e1; /* Цвет старой бумаги */
  color: #333;
  padding: 30px;
  width: 85%;
  border-radius: 2px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.8);
  transform: rotate(-1deg);
  text-align: center;
  font-family: 'Courier New', monospace;
}

.result-title {
  font-size: 24px;
  font-weight: 900;
  text-transform: uppercase;
  border-bottom: 3px double #333;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.result-row {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px dashed #aaa;
  padding: 8px 0;
  font-size: 16px;
}

.result-val { font-weight: bold; }

.close-btn {
  margin-top: 25px;
  width: 100%;
  padding: 12px;
  background: #3e2723;
  color: #fff8e1;
  border: none;
  font-family: inherit;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  text-transform: uppercase;
  box-shadow: 0 4px 0 #281815;
  transition: all 0.1s;
}

.close-btn:active {
  transform: translateY(3px);
  box-shadow: 0 1px 0 #281815;
}

@keyframes fadeIn {
  from { opacity: 0; } to { opacity: 1; }
}`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/sliding/SlidingPuzzle.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC,oDAAoD;AACpD;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;;EAEhB,0CAA0C;EAC1C;;6EAE2E;;EAE3E,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;;EAEnB,0BAA0B;EAC1B;;+BAE6B;;EAE7B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,WAAW,EAAE,kBAAkB,EAAE,SAAS,EAAE,WAAW,EAAE,YAAY;EACrE,gEAAgE;EAChE,kBAAkB,EAAE,qCAAqC;AAC3D;AACA,yBAAyB,UAAU,EAAE;AACrC,wBAAwB,WAAW,EAAE;;AAErC,sBAAsB;AACtB;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,QAAQ,EAAE,yBAAyB;EACnC,WAAW;EACX,gCAAgC;EAChC,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;;EAElB,8CAA8C;EAC9C,4CAA4C;AAC9C;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;;EAElB,kCAAkC;EAClC,6DAA6D;;EAE7D,UAAU;EACV,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;;EAEhB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;;EAEf,iBAAiB;EACjB;;6BAE2B,EAAE,mBAAmB;;EAEhD,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B;;6BAE2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mEAAmE;AACnE;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW;EAC5C,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB,EAAE,uBAAuB;EAC5C,WAAW;EACX,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,uCAAuC;EACvC,wBAAwB;EACxB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA,cAAc,iBAAiB,EAAE;;AAEjC;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE;AACxC","sourcesContent":["/* games/sliding/SlidingPuzzle.css */\n\n/* --- ГЛАВНЫЙ КОНТЕЙНЕР (ДЕРЕВЯННАЯ ШКАТУЛКА) --- */\n.sliding-board {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90%;\n  max-width: 360px;\n\n  /* Текстура темного лакированного дерева */\n  background:\n    linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.4)),\n    repeating-linear-gradient(45deg, #3e2723 0px, #4e342e 10px, #3e2723 20px);\n\n  /* Золотая/Латунная окантовка */\n  border: 6px solid #bcaaa4;\n  outline: 2px solid #3e2723;\n  border-radius: 12px;\n\n  /* Глубокая тень (объем) */\n  box-shadow:\n    inset 0 0 30px rgba(0,0,0,0.8),\n    0 20px 60px rgba(0,0,0,0.7);\n\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 6000;\n  font-family: 'Georgia', 'Times New Roman', serif;\n  color: #f5f5f5;\n  user-select: none;\n}\n\n/* Болтики по углам */\n.sliding-board::before, .sliding-board::after {\n  content: ''; position: absolute; top: 10px; width: 10px; height: 10px;\n  background: radial-gradient(circle at 30% 30%, #ffd54f, #ff6f00);\n  border-radius: 50%; box-shadow: 0 1px 2px rgba(0,0,0,0.5);\n}\n.sliding-board::before { left: 10px; }\n.sliding-board::after { right: 10px; }\n\n/* --- ЗАГОЛОВОК --- */\n.sliding-header {\n  width: 100%;\n  text-align: center;\n  margin-bottom: 20px;\n  border-bottom: 2px solid rgba(255,255,255,0.1);\n  padding-bottom: 10px;\n}\n\n.sliding-title {\n  font-size: 20px;\n  font-weight: bold;\n  letter-spacing: 2px;\n  color: #d7ccc8;\n  text-transform: uppercase;\n  text-shadow: 0 2px 2px rgba(0,0,0,0.8);\n}\n\n.sliding-stats {\n  margin-top: 5px;\n  font-size: 14px;\n  color: #a1887f;\n  font-family: monospace;\n  font-weight: bold;\n}\n\n/* --- ПОЛЕ ИГРЫ (УГЛУБЛЕНИЕ) --- */\n.sliding-grid {\n  display: grid;\n  gap: 8px; /* Зазор между плитками */\n  width: 100%;\n  /* Удаляем aspect-ratio: 1 / 1 */\n  /* Темное дно шкатулки */\n  background: #211512;\n  padding: 10px;\n  border-radius: 8px;\n\n  /* Внутренняя тень создает эффект углубления */\n  box-shadow: inset 0 2px 15px rgba(0,0,0,0.9);\n}\n\n/* --- ПЛИТКА (ЭМАЛЬ И ЛАТУНЬ) --- */\n.sliding-tile {\n  position: relative;\n\n  /* Эффект слоновой кости / эмали */\n  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);\n\n  /* Текст */\n  color: #3e2723;\n  /* Удаляем фиксированный font-size: 32px */\n  font-weight: 900;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 6px;\n  cursor: pointer;\n\n  /* Объем плитки */\n  box-shadow:\n    0 4px 0 #8d6e63, /* Толщина плитки */\n    0 6px 5px rgba(0,0,0,0.5); /* Тень от плитки */\n\n  transition: transform 0.1s;\n}\n\n.sliding-tile:active {\n  transform: translateY(3px);\n  box-shadow:\n    0 1px 0 #8d6e63,\n    0 2px 2px rgba(0,0,0,0.5);\n}\n\n/* Пустая ячейка - просто прозрачная */\n.sliding-tile.empty {\n  background: transparent;\n  box-shadow: none;\n  cursor: default;\n}\n\n/* Декоративная рамка внутри плитки (как на классических кубиках) */\n.sliding-tile:not(.empty)::after {\n  content: '';\n  position: absolute;\n  top: 4px; left: 4px; right: 4px; bottom: 4px;\n  border: 1px solid rgba(62, 39, 35, 0.2);\n  border-radius: 4px;\n}\n\n/* --- ОВЕРЛЕЙ ПОБЕДЫ (БУМАЖНЫЙ ЛИСТ) --- */\n.sliding-result-overlay {\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(5px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 50;\n  animation: fadeIn 0.4s;\n}\n\n.result-card {\n  background: #fff8e1; /* Цвет старой бумаги */\n  color: #333;\n  padding: 30px;\n  width: 85%;\n  border-radius: 2px;\n  box-shadow: 0 10px 40px rgba(0,0,0,0.8);\n  transform: rotate(-1deg);\n  text-align: center;\n  font-family: 'Courier New', monospace;\n}\n\n.result-title {\n  font-size: 24px;\n  font-weight: 900;\n  text-transform: uppercase;\n  border-bottom: 3px double #333;\n  padding-bottom: 10px;\n  margin-bottom: 20px;\n}\n\n.result-row {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px dashed #aaa;\n  padding: 8px 0;\n  font-size: 16px;\n}\n\n.result-val { font-weight: bold; }\n\n.close-btn {\n  margin-top: 25px;\n  width: 100%;\n  padding: 12px;\n  background: #3e2723;\n  color: #fff8e1;\n  border: none;\n  font-family: inherit;\n  font-weight: bold;\n  font-size: 16px;\n  cursor: pointer;\n  text-transform: uppercase;\n  box-shadow: 0 4px 0 #281815;\n  transition: all 0.1s;\n}\n\n.close-btn:active {\n  transform: translateY(3px);\n  box-shadow: 0 1px 0 #281815;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; } to { opacity: 1; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
